<template>
  <div>
    <Modal v-model="importModal" title="导入" @on-cancel="cancel('importForm')" @on-ok="submit('importForm')" :loading="loading"
           :mask-closable="false">
      <Form ref="importForm" :model="importForm" :label-width="120" enctype="multipart/form-data" :rules="ruleValidate">
        <!-- 公司 -->
        <div v-if="companyIdCookie==1">
          <FormItem :label="$t('LabelConfig.LabelSynchronization.company')" prop="companyId">
            <Select v-model="importForm.companyId" filterable style="width: 300px"  :placeholder="$t('RAM.common.PleaseSelectCompany')">
              <Option value="">{{ $t('configuration_management.common.all') }}</Option>
              <Option :value="item.id" v-for="(item,index) in companyList" v-bind:key="index">{{item.companyName}}</Option>
            </Select>
          </FormItem>
        </div>
        <FormItem :label="$t('RAM.AWS.computeInstance.CreationTime')" prop="createTimeString">
          <DatePicker type="month" format="yyyy-MM-dd"  :placeholder="$t('RAM.AWS.computeInstance.CreationTime')"  :value="importForm.createTimeString" @on-change="importForm.createTimeString=$event"
                      style="width: 300px;"></DatePicker>
        </FormItem>
        <!-- 上传模版 -->
        <FormItem :label="$t('message.uploadTemplate')">
          <Upload :before-upload="handleUpload" action="" :accept="Accept">
            <Button icon="ios-cloud-upload-outline">{{ $t('message.selectTemplate') }}</Button>
          </Upload>
          <div v-if="importForm.file !== null">{{ $t('message.templateName')  }}: {{ importForm.file.name }}</div>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>
<script>

  import {setCookie,getCookie} from '../../../utils/cookieUtil.js'
  export default {
    inject: ['reload'],
    data() {
      return {
        Accept: ".xlsx",//上传文件格式限制
        importModal: false,
        loading: true,
        companyList: [],
        companyIdCookie: getCookie(global.companyId),
        importForm: {
          createTimeString: '',
          file: '',
          companyId: '',
        },
        ruleValidate: {
          companyId: [
            {required: true, message: '请选择公司', trigger: 'change', type: 'number'}
          ],
          createTimeString: [
            { required: true, message: '请选择创建时间'}
          ]
        }
      }
    },
    mounted:function(){
      // 上传附件接口
      this.listCompany();
    },
    methods: {
      /************************* 查询 *******************************/
      init: function () {
        this.importModal = true;
      },
      handleUpload(file) {
        this.importForm.file = file;
        return false
      },
      // 公司列表
      listCompany: function () {
        this.$api.user.listRegisterInformation()
          .then(res => {
            // 获取公司列表数据
            this.companyList = res.data.companies;
          })
      },
      // 导入
      /**********************************************************************************/
      submit: function (name) {
        this.$refs[name].validate(valid => {
          if (valid) {
            let config = {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            };
            let formData = new FormData();
            for (let key in this.importForm) {
              formData.append(key, this.importForm[key])
            }
            if (this.importForm.file == null) {
              this.$Message.error('模版不能为空');
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });
            } else {
              this.$api.ticket.importFile(formData)
                .then(res => {
                  setTimeout(() => {
                    this.reload();
                    this.loading = false;
                    this.$refs[name].resetFields();
                    this.$nextTick(() => {
                      this.loading = true;
                    });
                    this.$Message.success('导入成功');
                    this.importModal = false;
                  }, 1000);
                });
            }
          }else {
            this.loading = false;
            setTimeout(() => {
              this.loading = true
            }, 0);
            this.$Message.error('导入失败');
          }
        });
      },
      // 返回
      cancel: function (name) {
        this.importModal = false;
        this.importForm.file = null;
        this.$nextTick(() => {
          this.$refs[name].resetFields();
        });
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/cases/case/Import.vue